import React, { useCallback, useState } from "react";
import AddToCartModal from "./AddToCartModal";
import Modal from "theme/components/organisms/Modal";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "modules.ProductAddedPopIn.youAdded",
    defaultMessage: "You just added the following product(s) to your cart:",
  },
});

export const STATUS_CLOSED = "closed";
export const STATUS_PENDING = "pending";
export const STATUS_ADDED = "added";
export const STATUS_DONE = "done";

const useAddToCartModal = ({
  product,
  selectedOptions,
  selectedCustomOptions,
  selectedBundleOptions,
  onSuccess,
}) => {
  const intl = useIntl();
  const [status, setStatus] = useState(STATUS_CLOSED);

  const addToCartModal = (
    <Modal
      isOpen={status !== STATUS_CLOSED && status !== STATUS_DONE}
      onRequestClose={() => {
        if (status === STATUS_ADDED) {
          onSuccess();
          setStatus(STATUS_DONE);
        } else {
          setStatus(STATUS_CLOSED);
        }
      }}
      title={
        status === STATUS_ADDED ? (
          intl.formatMessage(messages.title)
        ) : (
          <FormattedMessage
            id="modules.AddToCart.AddToCartModal.title"
            defaultMessage="Add product to cart"
          />
        )
      }
    >
      {status !== STATUS_CLOSED ? (
        <AddToCartModal
          product={product}
          selectedOptions={selectedOptions}
          selectedCustomOptions={selectedCustomOptions}
          selectedBundleOptions={selectedBundleOptions}
          onSuccess={() => {
            setStatus(STATUS_ADDED);
          }}
          onClose={() => {
            onSuccess();
            setStatus(STATUS_DONE);
          }}
        />
      ) : (
        ""
      )}
    </Modal>
  );

  const addToCart = useCallback(() => {
    setStatus(STATUS_PENDING);
  }, [setStatus]);

  return [addToCart, status, addToCartModal];
};

export default useAddToCartModal;
